/* eslint-disable simple-import-sort/imports */
import { IUserNotification, TableauEntityType } from '@tableau/user-notifications-client-core';
import _ from 'underscore';

import { IUserIdentityConflictInfo } from '~src/authentication/models/IUserIdentityConflictInfo';
import { IGetUserIdentityConflictsResult } from '~src/authentication/serverApi/requests/GetUserIdentityConflictsRequest';
import { IUserIdentityConflict } from '~src/authentication/serverApi/types/IUserIdentityConflict';
import { IDatabaseInfo } from '~src/catalog/models/IDatabaseInfo';
import { ITableInfo } from '~src/catalog/models/ITableInfo';
import { DatabaseWithCrassMapper } from '~src/catalog/models/mappers/DatabaseWithCrassMapper';
import { TableMapper } from '~src/catalog/models/mappers/TableWithCrassMapper';
import { IGetDatabasesResult } from '~src/catalog/serverApi/requests/databases/GetDatabasesRequest';
import { IGetTablesResult } from '~src/catalog/serverApi/requests/databases/GetTablesRequest';
import { IAccelerationTaskInfo } from '~src/dataAcceleration/models/IAccelerationTaskInfo';
import { IAccelerationRecommendationInfo } from '~src/dataAcceleration/models/IAccelerationRecommendationInfo';
import { AccelerationTaskMapper } from '~src/dataAcceleration/models/mappers/AccelerationTaskMapper';
import { AccelerationRecommendationMapper } from '~src/dataAcceleration/models/mappers/AccelerationRecommendationMapper';
import { IGetAccelerationTasksResult } from '~src/dataAcceleration/serverApi/requests/GetAccelerationTasksRequest';
import { IGetAccelerationRecommendationsResult } from '~src/dataAcceleration/serverApi/requests/GetAccelerationRecommendationsRequest';
import { IDataRoleInfo } from '~src/dataRole/models/IDataRoleInfo';
import { DataRoleMapper } from '~src/dataRole/models/mappers/DataRoleMapper';
import { IGetDataRolesResult } from '~src/dataRole/serverApi/requests/GetDataRolesRequest';
import { IDataConnectionInfo } from '~src/datasource/dataConnection/models/IDataConnectionInfo';
import { DataConnectionMapper } from '~src/datasource/dataConnection/models/mappers/DataConnectionMapper';
import { IGetDataConnectionsResult } from '~src/datasource/dataConnection/serverApi/GetDataConnectionsRequest';
import { IDataSourceInfo } from '~src/datasource/models/IDataSourceInfo';
import { DatasourceMapper } from '~src/datasource/models/mappers/DatasourceMapper';
import { IGetDatasourcesResult } from '~src/datasource/ServerApi/requests/GetDatasourcesRequest';
import { IAlertListInfo } from '~src/dda/models/IAlertInfo';
import { IDataAlertInfo } from '~src/dda/models/IDataAlertInfo';
import { AlertListMapper } from '~src/dda/models/mappers/AlertMapper';
import { DataAlertMapper } from '~src/dda/models/mappers/DataAlertMapper';
import { IGetDataAlertsResult } from '~src/dda/serverApi/requests/GetDataAlertsRequest';
import { IAlertList } from '~src/dda/serverApi/types/IAlert';
import { IRemoteRefreshAgentInfo } from '~src/extractRefresh/models/IRemoteRefreshAgentInfo';
import { IRemoteRefreshScheduleInfo } from '~src/extractRefresh/models/IRemoteRefreshScheduleInfo';
import { RemoteRefreshAgentMapper } from '~src/extractRefresh/models/mappers/RemoteRefreshAgentMapper';
import { RemoteRefreshScheduleMapper } from '~src/extractRefresh/models/mappers/RemoteRefreshScheduleMapper';
import { IGetRemoteRefreshAgentsResult } from '~src/extractRefresh/serverApi/requests/remoteExtractRefresh/GetRemoteRefreshAgentsRequest';
import { IRemoteRefreshSchedulesResult } from '~src/extractRefresh/serverApi/requests/remoteExtractRefresh/GetRemoteRefreshSchedulesRequest';
import { IExtractTaskInfo } from '~src/extractTask/models/IExtractTaskInfo';
import { ExtractTaskMapper } from '~src/extractTask/models/mappers/ExtractTaskMapper';
import { IGetExtractTasksResult } from '~src/extractTask/serverApi/requests/GetExtractTasksRequest';
import { ExploreFavoriteContentForUserResult } from '~src/favorites/requests/ExploreFavoriteContentForUserRequest';
import { IFavorite } from '~src/favorites/types/IFavorite';
import { FlowListItemInfo } from '~src/flow/models/FlowInfo';
import { FlowOutputStepInfo } from '~src/flow/models/FlowOutputStepInfo';
import { FlowOutputStepRunListItemInfo } from '~src/flow/models/FlowOutputStepRunInfo';
import { FlowMapper } from '~src/flow/models/mappers/FlowMapper';
import { FlowOutputStepMapper } from '~src/flow/models/mappers/FlowOutputStepMapper';
import { FlowOutputStepRunMapper } from '~src/flow/models/mappers/FlowOutputStepRunMapper';
import { RunFlowTaskMapper } from '~src/flow/models/mappers/RunFlowTaskMapper';
import { RunFlowTaskInfo } from '~src/flow/models/RunFlowTaskInfo';
import { GetFlowOutputStepRunsResult } from '~src/flow/serverApi/requests/GetFlowOutputStepRunsRequest';
import { GetFlowOutputStepsResult } from '~src/flow/serverApi/requests/GetFlowOutputStepsRequest';
import { GetFlowsResult } from '~src/flow/serverApi/requests/GetFlowsRequest';
import { FlowWithRunPermission, GetFlowsWithRunPermissionsResult } from '~src/flow/serverApi/requests/GetFlowsWithRunPermissionsRequest';
import { GetRunFlowTasksResult } from '~src/flow/serverApi/requests/GetRunFlowTasksRequest';
import { ILensInfo } from '~src/lens/models/ILensInfo';
import { LensMapper } from '~src/lens/models/mappers/LensMapper';
import { IGetLensesResult } from '~src/lens/serverApi/requests/GetLensesRequest';
import { LinkedTaskInfo } from '~src/linkedTasks/models/LinkedTaskInfo';
import { LinkedTaskMapper } from '~src/linkedTasks/models/mappers/LinkedTaskMapper';
import { GetLinkedTaskResult } from '~src/linkedTasks/serverApi/requests/GetLinkedTaskRequest';
import { IMetricInfo } from '~src/metrics/models/IMetricInfo';
import { MetricMapper } from '~src/metrics/models/mappers/MetricMapper';
import { IGetMetricsResult } from '~src/metrics/serverApi/requests/GetMetricsRequest';
import { IPredictiveModelInfo } from '~src/predictiveModel/models/IPredictiveModelInfo';
import { PredictiveModelMapper } from '~src/predictiveModel/models/mappers/PredictiveModelMapper';
import { IGetPredictiveModelsResult } from '~src/predictiveModel/serverApi/requests/GetPredictiveModelsRequest';
import { IProjectInfo } from '~src/projects/models/IProjectInfo';
import { ProjectMapper } from '~src/projects/models/mappers/ProjectMapper';
import { IGetProjectsResult } from '~src/projects/ServerApi/requests/GetProjectsRequest';
import { IPublishedConnectionInfo } from '~src/publishedConnection/models/IPublishedConnectionInfo';
import { PublishedConnectionMapper } from '~src/publishedConnection/models/mappers/PublishedConnectionMapper';
import { IGetPublishedConnectionColumnsResult } from '~src/publishedConnection/serverApi/requests/GetPublishedConnectionColumnsRequest';
import { IGetPublishedConnectionsResult } from '~src/publishedConnection/serverApi/requests/GetPublishedConnectionsRequest';
import { IPublishedConnectionColumnInfo, IPublishedConnectionTableInfo } from '~src/publishedConnectionTable/models/IPublishedConnectionTableInfo';
import { PublishedConnectionTableMapper } from '~src/publishedConnectionTable/models/mappers/PublishedConnectionTableMapper';
import { IGetPublishedConnectionTablesResult } from '~src/publishedConnectionTable/serverApi/requests/GetPublishedConnectionTablesRequest';
import { IRecentContentInfo } from '~src/recents/models/IRecentContentInfo';
import { IGetDetailedRecentsResult } from '~src/recents/requests/GetDetailedRecentsRequest';
import { IRecent } from '~src/recents/types/IRecent';
import { IViewRecommendationInfo } from '~src/recommendations/models/IViewRecommendationInfo';
import { IGetRecommendedViewsResult } from '~src/recommendations/serverApi/requests/GetRecommendedViewsRequest';
import { IViewRecommendation } from '~src/recommendations/serverApi/types/IViewRecommendation';
import { ISharedVersionInfo } from '~src/sharing/models/ISharedVersionInfo';
import { ISharedWithMeContentInfo } from '~src/sharing/models/ISharedWithMeContentInfo';
import { IGetServerUsersWithTokenResult } from '~src/userManagement/users/serverApi/requests/GetServerUsersWithTokenRequest';
import { ShareActivityMapper } from '~src/sharing/models/mappers/ShareActivityMapper';
import { SharedWithMeMapper } from '~src/sharing/models/mappers/SharedWithMeMapper';
import { IGetShareActivityResult, ISharedVersion } from '~src/sharing/serverApi/requests/GetShareActivityRequest';
import { IGetSharedWithMeResult } from '~src/sharing/serverApi/requests/GetSharedWithMeRequest';
import { ExplorableItemType } from '~src/spacesPlatform/models/ContentType';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { ISubscriptionInfo } from '~src/subscription/models/ISubscriptionInfo';
import { SubscriptionMapper } from '~src/subscription/models/mappers/SubscriptionMapper';
import { IGetSubscriptionsResult } from '~src/subscription/serverApi/requests/GetSubscriptionsRequest';
import { IGroupInfo } from '~src/userManagement/groups/models/IGroupInfo';
import { IGetGroupsResult } from '~src/userManagement/groups/serverApi/requests/GetGroupsRequest';
import { IGroup } from '~src/userManagement/groups/serverApi/types/IGroup';
import { IServerUserInfo } from '~src/userManagement/users/models/IServerUserInfo';
import { ISiteUserInfo } from '~src/userManagement/users/models/ISiteUserInfo';
import { IGetServerUsersResult } from '~src/userManagement/users/serverApi/requests/GetServerUsersRequest';
import { IGetSiteUsersResult } from '~src/userManagement/users/serverApi/requests/GetSiteUsersRequest';
import { IGetSiteUsersWithTokenResult } from '~src/userManagement/users/serverApi/requests/GetSiteUsersWithTokenRequest';
import { IServerUser } from '~src/userManagement/users/serverApi/types/IServerUser';
import { ISiteUser } from '~src/userManagement/users/serverApi/types/ISiteUser';
import { IGetUserNotificationsResult } from '~src/userNotifications/redux/serverRequests/GetUserNotificationsRequest';
import { ViewMapper } from '~src/views/mappers/ViewMapper';
import { IViewInfo } from '~src/views/models/IViewInfo';
import { IGetViewsResult } from '~src/views/ServerApi/requests/GetViewsRequest';
import { IWorkbookInfo } from '~src/workbook/models/IWorkbookInfo';
import { WorkbookMapper } from '~src/workbook/models/mappers/WorkbookMapper';
import { IGetWorkbooksResult } from '~src/workbook/ServerApi/requests/GetWorkbooksRequest';
import { ContentLineageRelationshipInfo } from '../../linkedTasks/models/ContentLineageRelationshipInfo';
import { ContentLineageRelationshipMapper } from '../../linkedTasks/models/mappers/ContentLineageRelationshipMapper';
import { GetContentLineageRelationshipsResult } from '../../linkedTasks/serverApi/requests/GetContentLineageRelationshipsRequest';
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { ContentMapper } from '../../spacesPlatform/models/mappers/ContentMapper';
import { LocationMapper } from '../../personalSpace/model/mappers/LocationMapper';
import { UserMapper } from '../../userManagement/users/models/mappers/UserMapper';
import { UserWithImageMapper } from '../../sharing/models/mappers/UserWithImageMapper';
import { IUserInfo } from '../../userManagement/users/models/IUserInfo';
import { mapContentFromCrass } from '../../spacesPlatform/resources/Search';
import { CustomViewMapper } from '../../views/ServerApi/requests/CustomViews/CustomViewMapper';
import { IGetCustomizedViewsResult } from '../../views/ServerApi/requests/CustomViews/GetCustomizedViewsRequest';
import { ICustomViewInfo } from '../../views/ServerApi/requests/CustomViews/ICustomViewInfo';
import { IGetFieldValuesResult } from '../../httpClient/serverApi/requests/GetFieldValuesRequest';
import { IFieldValue } from '../../httpClient/serverApi/types/IFieldValue';
import { IMetricUsageInfo, IUsageInfo } from '../../spacesPlatform/models/IUsageInfo';
import { IIdItem, IPathItem } from '../../spacesPlatform/models/resourceParts';
import { IExploreContentResult } from '~src/spacesPlatform/serverApi/requests/ExploreContentRequest';


export module ServerApiMapper {

  export function content(exploreContentResult: IExploreContentResult): IContentInfo[] {
    if (!exploreContentResult.content || exploreContentResult.content.length <= 0) return [];

    const users = index(UserMapper.map(exploreContentResult.users));

    return ContentMapper.map(exploreContentResult.content, users);
  }

  export function favoriteFromCrass(result: ExploreFavoriteContentForUserResult): IContentInfo[] {
    if (!result.content || result.content.length <= 0) return [];

    return result.content.map((item: any) => {
      return { ...mapContentFromCrass(item), favorite: true };
    });
  }

  // converts ExploreFavoriteContentForUser response to be the same structure as GetFavorites response
  export function favoriteFromExploreFavoriteContentForUser(result: ExploreFavoriteContentForUserResult): IFavorite[] {
    if (result?.content?.length > 0) {
      const favorites = result.content.map(item => {
        const contentInfo = mapContentFromCrass(item);
        return {
          id: item.id,
          objectId: contentInfo.id,
          objectLuid: contentInfo.luid,
          // idForFavoriting is only for datasources, see comment in IDataSourceInfo
          objectIdForFavoriting: contentInfo.contentType === 'datasource' ? (contentInfo as IDataSourceInfo).idForFavoriting : contentInfo.id,
          objectName: contentInfo.name,
          objectType: contentInfo.contentType,
        };
      });

      return favorites;
    } else {
      return [];
    }
  }

  export function predictiveModels(result: IGetPredictiveModelsResult): IPredictiveModelInfo[] {
    if (!result.predictiveModels || result.predictiveModels.length <= 0) return [];

    const users = index(UserMapper.map(result.users));
    const locations = LocationMapper.map(result.containers);

    return PredictiveModelMapper.map(result.predictiveModels, users, locations, favorites(result.favorites));
  }

  export function projects(projectResult: IGetProjectsResult): IProjectInfo[] {
    if (!projectResult.projects || projectResult.projects.length <= 0) return [];

    const users = index(UserMapper.map(projectResult.users));

    return ProjectMapper.map(projectResult.projects, users, favorites(projectResult.favorites));
  }

  export function dataRoles(dataRoleResult: IGetDataRolesResult): IDataRoleInfo[] {
    if (!dataRoleResult.dataRoles || dataRoleResult.dataRoles.length <= 0) return [];

    const users = index(UserMapper.map(dataRoleResult.users));
    const projects = index(ProjectMapper.mapNames(dataRoleResult.projects));
    const locations = LocationMapper.map(dataRoleResult.containers);

    return DataRoleMapper.map(dataRoleResult.dataRoles, users, favorites(dataRoleResult.favorites), projects, locations);
  }

  export function lenses(lensResult: IGetLensesResult): ILensInfo[] {
    if (!lensResult.lenses || lensResult.lenses.length <= 0) {
      return [];
    }

    const users = index(UserMapper.map(lensResult.users));
    const projects = index(ProjectMapper.mapNames(lensResult.projects));

    return LensMapper.map(lensResult.lenses, users, favorites(lensResult.favorites), projects);
  }

  export function publishedConnections(result: IGetPublishedConnectionsResult): IPublishedConnectionInfo[] {
    if (!result.publishedConnections || result.publishedConnections.length <= 0) return [];

    const users = index(UserMapper.map(result.users));
    const projects = index(ProjectMapper.mapNames(result.projects));

    return PublishedConnectionMapper.map(result.publishedConnections, users, projects, favorites(result.favorites));
  }

  export function publishedConnectionTables(result: IGetPublishedConnectionTablesResult): IPublishedConnectionTableInfo[] {
    if (!result.publishedConnectionTables || result.publishedConnectionTables.length <= 0) return [];

    const users = index(UserMapper.map(result.users));
    const projects = index(ProjectMapper.mapNames(result.projects));

    return PublishedConnectionTableMapper.map(result.publishedConnectionTables, users, projects, favorites(result.favorites));
  }

  export function publishedConnectionColumns(result: IGetPublishedConnectionColumnsResult): IPublishedConnectionColumnInfo[] {
    if (!result.publishedConnectionColumns || result.publishedConnectionColumns.length <= 0) return [];

    return PublishedConnectionTableMapper.mapColumns(result.publishedConnectionColumns);
  }

  export function dataConnections(dataConnectionsResult: IGetDataConnectionsResult): IDataConnectionInfo[] {
    if (!dataConnectionsResult.dataConnections || dataConnectionsResult.dataConnections.length <= 0) {
      return [];
    }

    const users = index(UserMapper.map(dataConnectionsResult.users));
    const projects = index(ProjectMapper.mapNames(dataConnectionsResult.projects));
    const workbooks = index(dataConnectionsResult.workbooks);
    const dataSources = dataConnectionsResult.datasources
      ? index(DatasourceMapper.mapBasic(dataConnectionsResult.datasources, users, projects, workbooks))
      : {};
    const flows = dataConnectionsResult.flows
      ? index(FlowMapper.mapBasic(dataConnectionsResult.flows, users, projects))
      : {};

    return DataConnectionMapper.map(dataConnectionsResult.dataConnections, dataSources, flows);
  }

  export function dataSources(dataSourcesResult: IGetDatasourcesResult): IDataSourceInfo[] {
    if (!dataSourcesResult.datasources || dataSourcesResult.datasources.length <= 0) return [];

    const users = index(UserMapper.map(dataSourcesResult.users));
    const projects = index(ProjectMapper.mapNames(dataSourcesResult.projects));
    const workbooks = index(dataSourcesResult.workbooks);
    const locations = LocationMapper.map(dataSourcesResult.containers);

    return DatasourceMapper.map(dataSourcesResult.datasources, users, projects, locations, workbooks, dataSourcesResult.maxStats,
      favorites(dataSourcesResult.favorites));
  }

  export function databasesUsingCrass(databasesResult: IGetDatabasesResult): IDatabaseInfo[] {
    if (!databasesResult.databases || databasesResult.databases.length <= 0) return [];
    if (FeatureFlags.databasesInProjectsEnabled){
      const containers = index(ProjectMapper.mapNames(databasesResult.containers));
      return DatabaseWithCrassMapper.map(databasesResult.databases, containers, databasesResult.maxDownstreamDatasourcesViewModel, databasesResult.maxDownstreamWorkbooksViewModel);
    }
    return DatabaseWithCrassMapper.map(databasesResult.databases, null, databasesResult.maxDownstreamDatasourcesViewModel, databasesResult.maxDownstreamWorkbooksViewModel);
  }

  export function tablesUsingCrass(tablesResult: IGetTablesResult): ITableInfo[] {
    if (!tablesResult.tables || tablesResult.tables.length <= 0) return [];

    if(FeatureFlags.tablesInProjectsEnabled) {
      const containers = index(ProjectMapper.mapNames(tablesResult.containers));
      return TableMapper.map(tablesResult.tables, containers, tablesResult.maxDownstreamDatasourcesViewModel, tablesResult.maxDownstreamWorkbooksViewModel);
    }
    return TableMapper.map(tablesResult.tables, null, tablesResult.maxDownstreamDatasourcesViewModel, tablesResult.maxDownstreamWorkbooksViewModel);
  }

  export function workbooks(workbooksResult: IGetWorkbooksResult): IWorkbookInfo[] {
    if (!workbooksResult.workbooks || workbooksResult.workbooks.length <= 0) return [];

    const users = index(UserMapper.map(workbooksResult.users));
    const projects = index(ProjectMapper.mapNames(workbooksResult.projects));
    const locations = LocationMapper.map(workbooksResult.containers);

    return WorkbookMapper.map(workbooksResult.workbooks, users, projects, locations, workbooksResult.maxStats,
      favorites(workbooksResult.favorites));
  }

  export function views(viewResult: IGetViewsResult): IViewInfo[] {
    if (!viewResult.views || viewResult.views.length <= 0) return [];

    const users = index(UserMapper.map(viewResult.users));
    const projects = index(ProjectMapper.mapNames(viewResult.projects));
    const locations = LocationMapper.map(viewResult.containers);
    const workbooks = index(WorkbookMapper.mapParents(viewResult.workbooks, users, projects, locations));
    const recents = _.indexBy(viewResult.recents, 'objectId');
    const viewAccelerations = _.indexBy(viewResult.viewAccelerations, 'viewId');

    return ViewMapper.map(viewResult.views, workbooks, viewResult.maxStats, favorites(viewResult.favorites), recents, viewAccelerations);
  }

  export function userNotifications(results: IGetUserNotificationsResult): IUserNotification<any>[] {
    if (!results.userNotifications || results.userNotifications.length <= 0) return [];

    return _.map(results.userNotifications, (notification): IUserNotification<any> => {
      return {
        ...notification,
        eventTime: new Date(notification.eventTime),
        creationTime: new Date(notification.creationTime),
        targetInfo: { ...notification.targetInfo, type: TableauEntityType[notification.targetInfo.type] }
      };
    });
  }

  export function recentItems(recentsResult: IGetDetailedRecentsResult): IRecentContentInfo[] {
    if (!recentsResult.recents || recentsResult.recents.length <= 0) {
      return [];
    }

    const users = index(UserMapper.map(recentsResult.users));
    const projects = index(ProjectMapper.mapNames(recentsResult.projects));
    const locations = LocationMapper.map(recentsResult.containers);
    const workbooks = index(WorkbookMapper.mapParents(recentsResult.workbooks, users, projects, locations));
    const views = index(ViewMapper.map(recentsResult.views, workbooks, recentsResult.viewMaxStats, favorites(recentsResult.viewFavorites)));
    const connectedViews = recentsResult.connectedViews ? indexByPath(MetricMapper.mapConnectedViews(recentsResult.connectedViews)) : {};
    const metrics = recentsResult.metrics ? index(MetricMapper.map(recentsResult.metrics, users, projects, locations, connectedViews, <IMetricUsageInfo>{}, favorites(recentsResult.metricFavorites)))
      : {};
    const flows = recentsResult.flows ? index(FlowMapper.map(recentsResult.flows, users, projects, locations, <IUsageInfo>{}, favorites(recentsResult.flowFavorites)))
      : {};

    const itemsInRecentOrder: IRecentContentInfo[] = recentsResult.recents
      .filter((recent: IRecent) => recent.objectType === 'view'
        || recent.objectType === 'metric'
        || recent.objectType === 'flow')
      .map((recent: IRecent) => {
        switch (recent.objectType) {
          case 'view':
            return { ...views[recent.objectId], lastAccessedAt: recent.lastAccessedAt };
          case 'metric':
            return { ...metrics[recent.objectId], lastAccessedAt: recent.lastAccessedAt };
          case 'flow':
            return { ...flows[recent.objectId], lastAccessedAt: recent.lastAccessedAt };
        }
      });

    return itemsInRecentOrder;
  }

  export function recentUniqueUsers(recentsResult: IGetDetailedRecentsResult): IUserInfo[] {
    if (!recentsResult.recents || recentsResult.recents.length <= 0) {
      return [];
    }

    const users = index(UserMapper.map(recentsResult.users));
    const projects = index(ProjectMapper.mapNames(recentsResult.projects));
    const locations = LocationMapper.map(recentsResult.containers);
    const workbooks = index(WorkbookMapper.mapParents(recentsResult.workbooks, users, projects, locations));
    const views = index(ViewMapper.map(recentsResult.views, workbooks, recentsResult.viewMaxStats, favorites(recentsResult.viewFavorites)));
    const connectedViews = recentsResult.connectedViews ? indexByPath(MetricMapper.mapConnectedViews(recentsResult.connectedViews)) : {};
    const metrics = recentsResult.metrics ? index(MetricMapper.map(recentsResult.metrics, users, projects, locations, connectedViews, <IMetricUsageInfo>{}, favorites(recentsResult.metricFavorites)))
      : {};
    const flows = recentsResult.flows ? index(FlowMapper.map(recentsResult.flows, users, projects, locations, <IUsageInfo>{}, favorites(recentsResult.flowFavorites)))
      : {};

    const recentUsers: IUserInfo[] = recentsResult.recents
      .filter((recent: IRecent) => recent.objectType === 'view'
        || recent.objectType === 'metric'
        || recent.objectType === 'flow')
      .map((recent: IRecent) => {
        switch (recent.objectType) {
          case 'view':
            return views[recent.objectId].workbook.owner;
          case 'metric':
            return metrics[recent.objectId].owner;
          case 'flow':
            return flows[recent.objectId].owner;
        }
      });

    if (FeatureFlags.aggregateRecentUsers) {
      let idToCount = new Map();
      let idToUser = new Map();

      recentUsers.forEach(user => {
        if (idToCount.has(user.id)) {
          idToCount.set(user.id, idToCount.get(user.id) + 1);
        } else {
          idToCount.set(user.id, 1);
          idToUser.set(user.id, user);
        }
      });

      let userCounts = Array.from(idToCount.entries());
      userCounts.sort((a, b) => { return b[1] - a[1]; });

      return userCounts.map(u => idToUser.get(u[0]));
    } else {
      let userIds = new Set();
      let uniqueUsers: IUserInfo[] = [];

      recentUsers.forEach(user => {
        if (!userIds.has(user.id)) {
          userIds.add(user.id);
          uniqueUsers.push(user);
        }
      });

      return uniqueUsers;
    }
  }

  export function metrics(metricsResult: IGetMetricsResult): IMetricInfo[] {
    if (!metricsResult.metrics || metricsResult.metrics.length <= 0) return [];

    const users = index(UserMapper.map(metricsResult.users));
    const connectedViews = indexByPath(MetricMapper.mapConnectedViews(metricsResult.connectedViews));
    const projects = index(ProjectMapper.mapNames(metricsResult.projects));
    const locations = LocationMapper.map(metricsResult.containers);

    return MetricMapper.map(metricsResult.metrics, users, projects, locations, connectedViews, metricsResult.maxStats, favorites(metricsResult.favorites));
  }

  export function vizRecommendations(vizRecommendationsResult: IGetRecommendedViewsResult): IViewRecommendationInfo[] {
    if (!vizRecommendationsResult.recommendations || vizRecommendationsResult.recommendations.length <= 0) return [];

    const users = index(UserMapper.map(vizRecommendationsResult.users));
    const projects = index(ProjectMapper.mapNames(vizRecommendationsResult.projects));
    const workbooks = index(WorkbookMapper.mapParents(vizRecommendationsResult.workbooks, users, projects));
    const views = index(ViewMapper.map(vizRecommendationsResult.views, workbooks, vizRecommendationsResult.viewMaxStats));
    const modelId = vizRecommendationsResult.modelId;

    const rankedRecs: IViewRecommendationInfo[] = vizRecommendationsResult.recommendations
      // filter out views from recommendation model that is no longer available in views array
      .filter((vizRec: IViewRecommendation) => views[vizRec.objectId])
      .map((vizRec: IViewRecommendation) => {
        const recommendedView = { ...views[vizRec.objectId], contentType: 'recommendedView' as const };
        return {
          ...recommendedView,
          modelId: modelId,
          hide: false,
          favoritesTotal: recommendedView.usageInfo.favoritesTotal,
          explanationType: vizRec.explanation.type,
          similiarUsers: vizRec.explanation.userIds && vizRec.explanation.userIds.map(userId => users[userId])
        };
      }) || [];
    return rankedRecs;
  }

  export function shareActivity(shareActivityResult: IGetShareActivityResult): ISharedVersionInfo[] {
    if (!shareActivityResult.shareActions || shareActivityResult.shareActions.length <= 0) return [];

    const deletedSharers = index(UserMapper.map(shareActivityResult.deletedSharers));
    const sharers = index(UserWithImageMapper.map(shareActivityResult.sharers));

    let sharedVersionsByTypeThenId: _.Dictionary<_.Dictionary<ISharedVersion>> = {};
    const sharedVersionsByType = _.groupBy(shareActivityResult.viewOrCustomizedViews, 'contentType');
    Object.keys(sharedVersionsByType).forEach((type: string) => {
      sharedVersionsByTypeThenId[type] = index(sharedVersionsByType[type]);
    });

    return ShareActivityMapper.map(shareActivityResult.shareActions, sharedVersionsByTypeThenId, sharers, deletedSharers);
  }

  export function sharedWithMe(sharedWithMeResult: IGetSharedWithMeResult): ISharedWithMeContentInfo[] {
    if (!sharedWithMeResult.shareActions || sharedWithMeResult.shareActions.length <= 0) return [];

    const deletedSharers = index(UserMapper.map(sharedWithMeResult.deletedSharers));
    const owners = index(UserMapper.map(sharedWithMeResult.owners));
    const sharers = index(UserWithImageMapper.map(sharedWithMeResult.sharers));
    const customViews = index(sharedWithMeResult.underhoodCustomizedViews);
    const contentList = ContentMapper.map(sharedWithMeResult.content, owners);

    const contentByType = groupByContentType(contentList);
    let contentByTypeThenId: _.Dictionary<_.Dictionary<IContentInfo<ExplorableItemType>>> = {};
    Object.keys(contentByType).forEach((type: string) => {
      let contents = index(contentByType[type]);
      contentByTypeThenId[type] = contents;
    });

    return SharedWithMeMapper.map(sharedWithMeResult.shareActions, contentByTypeThenId, sharers, deletedSharers, sharedWithMeResult.viewsWithShareActivity, customViews);
  }

  export function flows(flowsResult: GetFlowsResult): FlowListItemInfo[] {
    if (!flowsResult.flows || flowsResult.flows.length <= 0) return [];

    const users = index(UserMapper.map(flowsResult.users));
    const projects = index(ProjectMapper.mapNames(flowsResult.projects));
    const locations = LocationMapper.map(flowsResult.containers);

    return FlowMapper.map(flowsResult.flows, users, projects, locations, flowsResult.maxStats, favorites(flowsResult.favorites));
  }

  export function flowsWithPermissions(flowsResult: GetFlowsWithRunPermissionsResult): FlowWithRunPermission[] {
    if (!flowsResult.contents || flowsResult.contents.length <= 0) return [];
    return flowsResult.contents;
  }


  export function flowOutputSteps(flowOutputStepsResult: GetFlowOutputStepsResult): FlowOutputStepInfo[] {
    if (!flowOutputStepsResult.outputSteps || flowOutputStepsResult.outputSteps.length <= 0) return [];

    const connections = index(flowOutputStepsResult.dataConnections);
    const datasources = index(flowOutputStepsResult.datasources);

    return FlowOutputStepMapper.map(flowOutputStepsResult.outputSteps, connections, datasources, null);
  }

  export function flowOutputStepRuns(flowOutputStepRunsResult: GetFlowOutputStepRunsResult): FlowOutputStepRunListItemInfo[] {
    if (!flowOutputStepRunsResult.flowOutputStepRuns || flowOutputStepRunsResult.flowOutputStepRuns.length <= 0) return [];

    const outputSteps = index(flowOutputStepRunsResult.flowOutputSteps);
    const runs = index(flowOutputStepRunsResult.flowRuns);

    return FlowOutputStepRunMapper.map(flowOutputStepRunsResult.flowOutputStepRuns, outputSteps, runs);
  }

  export function contentLineageRelationships(contentLineageRelationshipsResult: GetContentLineageRelationshipsResult): ContentLineageRelationshipInfo[] {
    if (contentLineageRelationshipsResult?.contentLineageRelationships?.length <= 0) return [];

    const contentLineageRelationships = contentLineageRelationshipsResult.contentLineageRelationships;

    return ContentLineageRelationshipMapper.map(contentLineageRelationships);
  }

  export function alertList(alertList: IAlertList): IAlertListInfo {
    if (!(alertList && alertList.alerts && alertList.alerts.length > 0)) return { total: 0, alerts: [] };

    const workbooks = index(alertList.workbooks);
    const datasources = index(alertList.datasources);
    const flowOutputStepRuns = index(alertList.flowOutputStepRuns);
    const flowOutputSteps = index(alertList.flowOutputSteps);
    const flows = index(alertList.flows);

    return AlertListMapper.map(alertList.totalCount, alertList.alerts, workbooks, datasources, flowOutputStepRuns, flowOutputSteps, flows);
  }

  export function accelerationTasks(accelerationTaskResult: IGetAccelerationTasksResult): IAccelerationTaskInfo[] {
    if (_.size(accelerationTaskResult.tasks) <= 0) return [];

    const views = index(accelerationTaskResult.views);
    const workbooks = index(accelerationTaskResult.workbooks);
    const projects = index(accelerationTaskResult.projects);
    const users = index(accelerationTaskResult.users);
    const sites = index(accelerationTaskResult.sites);

    return AccelerationTaskMapper.map(accelerationTaskResult.tasks, views, workbooks, projects, users, sites);
  }

  export function accelerationRecommendations(accelerationRecommendationResult: IGetAccelerationRecommendationsResult): IAccelerationRecommendationInfo[] {
    if (_.size(accelerationRecommendationResult.recommendations) <= 0) return [];

    const views = index(accelerationRecommendationResult.views);
    const workbooks = index(accelerationRecommendationResult.workbooks);
    const projects = index(accelerationRecommendationResult.projects);

    return AccelerationRecommendationMapper.map(accelerationRecommendationResult.recommendations, views, workbooks, projects);
  }

  export function extractTasks(extractTaskResult: IGetExtractTasksResult): IExtractTaskInfo[] {
    if (_.size(extractTaskResult.tasks) <= 0) return [];

    const schedules = index(extractTaskResult.schedules);
    const sites = index(extractTaskResult.sites);
    const workbooks = index(extractTaskResult.workbooks);
    const datasources = index(extractTaskResult.datasources);
    const publishedConnections = index(extractTaskResult.publishedConnections);
    const extractServiceTasks = index(extractTaskResult.extractServiceTasks);

    return ExtractTaskMapper.map(extractTaskResult.tasks, schedules, sites, workbooks, datasources, publishedConnections, extractServiceTasks);
  }

  export function runFlowTasks(runFlowTasksResult: GetRunFlowTasksResult): RunFlowTaskInfo[] {
    if (runFlowTasksResult == null) return;
    if (_.size(runFlowTasksResult.tasks) <= 0) return [];

    const schedules = index(runFlowTasksResult.schedules);
    const sites = index(runFlowTasksResult.sites);
    const flows = index(runFlowTasksResult.flows);
    const flowOutputSteps = index(runFlowTasksResult.flowOutputSteps);
    const flowOutputStepRuns = runFlowTasksResult.flowOutputStepRuns;
    const flowRuns = runFlowTasksResult.flowRuns;
    const dataConnections = index(runFlowTasksResult.dataConnections);
    const datasources = index(runFlowTasksResult.datasources);

    return RunFlowTaskMapper.map(runFlowTasksResult.tasks, schedules, sites, flows, dataConnections, flowOutputSteps, flowRuns, flowOutputStepRuns, datasources);
  }

  export function linkedTask(getLinkedTaskResult: GetLinkedTaskResult): LinkedTaskInfo {
    if (getLinkedTaskResult == null) return;
    const flows = index(getLinkedTaskResult.flows);
    const outputSteps = index(getLinkedTaskResult.outputSteps);
    const dataConnections = index(getLinkedTaskResult.dataConnections);
    const datasources = index(getLinkedTaskResult.datasources);

    return LinkedTaskMapper.map(getLinkedTaskResult.linkedTask, flows, outputSteps, dataConnections, datasources);
  }

  export function remoteRefreshSchedules(remoteRefreshSchedulesResult: IRemoteRefreshSchedulesResult): IRemoteRefreshScheduleInfo[] {
    if (_.size(remoteRefreshSchedulesResult.schedules) <= 0) return [];

    return RemoteRefreshScheduleMapper.mapToResource(remoteRefreshSchedulesResult);
  }

  export function remoteRefreshAgents(remoteRefreshAgentsResult: IGetRemoteRefreshAgentsResult): IRemoteRefreshAgentInfo[] {
    if (_.size(remoteRefreshAgentsResult.agents) <= 0) return [];

    return RemoteRefreshAgentMapper.mapToResource(remoteRefreshAgentsResult.agents);
  }

  export function customViews(customViewResult: IGetCustomizedViewsResult): ICustomViewInfo[] {
    if (_.size(customViewResult.customViews) <= 0) return [];

    return CustomViewMapper.map(
      customViewResult.customViews,
      index(customViewResult.sites),
      customViewResult.maxStats,
      index(customViewResult.users),
    );
  }

  export function subscriptions(subscriptionResult: IGetSubscriptionsResult): ISubscriptionInfo[] {
    if (_.size(subscriptionResult.subscriptions) <= 0) return [];

    return SubscriptionMapper.map(
      subscriptionResult.subscriptions,
      index(subscriptionResult.schedules),
      index(subscriptionResult.sites),
      index(subscriptionResult.users)
    );
  }

  export function dataAlerts(dataAlertsResult: IGetDataAlertsResult): IDataAlertInfo[] {
    if (_.size(dataAlertsResult.dataAlerts) <= 0) return [];

    return DataAlertMapper.map(
      dataAlertsResult.dataAlerts,
      index(dataAlertsResult.users),
      index(dataAlertsResult.groups)
    );
  }

  export function groups(groupsResult: IGetGroupsResult): IGroupInfo[] {
    return groupsResult.groups.map((group: IGroup) => {
      const groupInfo: IGroupInfo = {
        ...group,
        contentType: 'group'
      };
      return groupInfo;
    });
  }

  export function siteUsers(siteUsersResult: IGetSiteUsersResult): ISiteUserInfo[] {
    return siteUsersResult.users.map((user: ISiteUser) => {
      const userInfo: ISiteUserInfo = {
        ...user,
        contentType: 'siteuser'
      };
      return userInfo;
    });
  }

  export function siteUsersWithToken(siteUsersWithTokenResult: IGetSiteUsersWithTokenResult): ISiteUserInfo[] {
    return siteUsersWithTokenResult.users.map((user: ISiteUser) => {
      const userInfo: ISiteUserInfo = {
        ...user,
        contentType: 'siteuser'
      };
      return userInfo;
    });
  }

  export function serverUsers(serverUsersResult: IGetServerUsersResult): IServerUserInfo[] {
    return serverUsersResult.users.map((user: IServerUser) => {
      const userInfo: IServerUserInfo = {
        ...user,
        contentType: 'serveruser'
      };
      return userInfo;
    });
  }

  export function serverUsersWithToken(serverUsersWithTokenResult: IGetServerUsersWithTokenResult): IServerUserInfo[] {
    return serverUsersWithTokenResult.users.map((user: IServerUser) => {
      const userInfo: IServerUserInfo = {
        ...user,
        contentType: 'serveruser'
      };
      return userInfo;
    });
  }

  export function userIdentityConflicts(userIdentityConflictsResult: IGetUserIdentityConflictsResult): IUserIdentityConflictInfo[] {
    return userIdentityConflictsResult.userIdentityConflicts.map((user: IUserIdentityConflict) => {
      const identityConflictInfo: IUserIdentityConflictInfo = {
        ...user,
        contentType: 'userIdentityConflict'
      };
      return identityConflictInfo;
    });
  }

  export function fieldValues(fieldValueResult: IGetFieldValuesResult): IFieldValue[] {
    return fieldValueResult.fieldValues;
  }

  function favorites(ids: string[]) {
    return _.indexBy(ids, _.identity);
  }

  function index<T extends IIdItem>(items: ReadonlyArray<T>): _.Dictionary<T> {
    return _.indexBy(items, 'id');
  }

  function indexByPath<T extends IPathItem>(items: ReadonlyArray<T>): _.Dictionary<T> {
    return _.indexBy(items, 'path');
  }

  function groupByContentType<T extends IContentInfo>(items: ReadonlyArray<T>): _.Dictionary<T[]> {
    return _.groupBy(items, 'contentType');
  }
}
